import { Stack, Tooltip, useTheme } from '@mui/material';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { CheckIcon } from '@shared/custom-icons';
import { getLLDate } from '@retail/utils';

interface Props {
  inAssortment?: boolean;
  priorityValidFrom: Date;
  priorityValidTo?: Date;
}

export const AssortmentItemStatus = ({
  inAssortment,
  priorityValidFrom,
  priorityValidTo,
}: Props) => {
  const theme = useTheme();
  const t = useMyAssortmentTFunction();

  if (priorityValidTo) {
    return (
      <Tooltip
        title={
          <Stack alignItems="center">
            {t('myAssortment.columns.removedFrom')} {getLLDate(priorityValidTo)}
          </Stack>
        }
      >
        <Stack alignItems={'center'} gap={0.5}>
          <CheckIcon color={theme.vars.palette.warning.main} />
        </Stack>
      </Tooltip>
    );
  }

  if (priorityValidFrom > new Date()) {
    return (
      <Tooltip title={t('myAssortment.columns.futurePrice')}>
        <Stack alignItems={'center'} gap={0.5}>
          <CheckIcon color={theme.vars.palette.secondary.main} />
        </Stack>
      </Tooltip>
    );
  }

  if (inAssortment) {
    return (
      <Tooltip title={t('myAssortment.status.inAssortment')}>
        <Stack alignItems={'center'} gap={0.5}>
          <CheckIcon color={theme.vars.palette.success.main} />
        </Stack>
      </Tooltip>
    );
  }
  return null;
};
